// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDeleteUserOutlinedSvg from "@fishx/icons-svg/es/asn/PDeleteUserOutlined";
import FishxIcon from '../components/FishxIcon';

var PDeleteUserOutlined = function PDeleteUserOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDeleteUserOutlinedSvg
  }));
};

PDeleteUserOutlined.displayName = 'PDeleteUserOutlined';
export default React.forwardRef(PDeleteUserOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDeleteUserOutlined.js
// module id = 3323
// module chunks = 0